import getGeoZone from '@picsart/growth-rc/services/getGeoZone';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { GeoZoneState } from './types';

const compare = (a, b) => {
  return a === b || shallow(a, b);
};
const useGeoZoneStore = createWithEqualityFn<GeoZoneState>(
  set => ({
    countryCode: null,
    loading: true,
    setCountryCode: data => set({ countryCode: data, loading: false }),
    fetchGeoZone: async () => {
      await getGeoZone()
        .then(geoZone => {
          set({ loading: false, countryCode: geoZone.country_code });
        })
        .catch(() => set({ loading: false }));
    },
  }),
  compare,
);

export default useGeoZoneStore;
